import React, { useContext, useState, useEffect, useCallback } from "react";
import { GblContext } from "providers/formatter";
import { useAuthState, useTranslate, useLocale } from "react-admin";
import {
  TextFieldInForm,
  NumberFormatInForm,
  MuiAutosuggest,
  DateInForm,
  DescInForm,
  SelectInForm,
  CheckBoxInForm,
} from "components/Form";
import {
  getAccountCodeList,
  getDepartmentList,
  getApPaymentTypeList,
  getUnitList,
  getMailProfile,
} from "services/setting";
import { getWorkflowByCode, getWorkflowStep } from "services/workflow";
import { getEnumApInvoiceStatus } from "services/enum";
import { getLookupCurrency } from "services/lookup";
import { getApVendorList, getTaxProfile } from "services/accountPayable";
import List from "./List";
import Show from "./Show";
import Edit from "./Edit";
import Create from "./Create";
import {
  VatTypeOptions,
  InvoiceTaxStatusOptions,
  PeriodList,
} from "utils/options";
import { makeStyles } from "@material-ui/core/styles";
import { addDays } from "date-fns";
import SnackbarUtils from "utils/SnackbarUtils";
import { Hidden } from "@material-ui/core";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: 12,
    marginBottom: 12,
  },
  footerCell: {
    backgroundColor: theme.palette.background.paper,
    borderTop: "2px solid rgba(224, 224, 224, 1)",
    borderBottom: "none",
  },
  stickyFooterCell: {
    position: "sticky",
    bottom: 0,
    zIndex: 100,
    textAlign: "right",
    fontSize: "0.9rem",
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  drawerOpen: {
    marginRight: drawerWidth,
  },
  drawerClose: {
    marginRight: 54,
  },
  content: {
    padding: 4,
  },
  wfBtn: {
    padding: "8px 0 8px 8px",
    marginBottom: "10px",
    textAlign: "right",
  },
  colorCell: {
    backgroundColor: "#34558b",
    color: "#fff",
    width: "50px",
    position: "sticky",
    top: 0,
  },
  divComment: {
    position: "relative",
    height: "20px",
    width: "200px",
  },
  parentStyle: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    boxSizing: "border-box",
    display: "block",
    width: "100%",
  },
  cellStyleEllipsis: {
    boxSizing: "border-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

const SwitchActionMode = (props) => {
  const locale = useLocale();
  const translate = useTranslate();
  const { authenticated } = useAuthState();
  const [wfSteps, setWfSteps] = useState();
  const [wfEnumStatus, setWfEnumStatus] = useState();
  const { settingAll, ToMySqlDate, ToNumber } = useContext(GblContext);
  const { SettingClosePeriod, SettingSystem } = settingAll;
  const { ClosePeriodGl, ClosePeriodAp } = SettingClosePeriod;
  const newClosePeriodGl = addDays(new Date(ClosePeriodGl), 1);
  const newClosePeriodAp = addDays(new Date(ClosePeriodAp), 1);
  const [oldAccList, setOldAccList] = useState([]);

  const addMode = props.location.pathname.search("create") !== -1;
  const copyMode = props.location.pathname.search("copy") !== -1;
  const IsSettled = JSON.parse(localStorage.getItem("IsSettled") ?? false);

  const [lookupList, setLookupList] = useState({
    accountCodeListDR: [],
    accountCodeListCR: [],
    accountCodeListTAX: [],
    accountCodeListTAX2: [],
    department: [],
    currency: [],
    vendor: [],
    apPaymentType: [],
    unit: [],
    taxProfileList: [],
  });
  const fetchAccLookup = useCallback(async () => {
    const { Data } = await getAccountCodeList("Ap");
    setLookupList((state) => ({
      ...state,
      accountCodeListDR: Data,
      accountCodeListCR: Data,
      accountCodeListTAX: Data,
      accountCodeListTAX2: Data,
    }));
    setOldAccList(Data);
  }, []);
  const fetchDeptLookup = useCallback(async () => {
    const { Data } = await getDepartmentList();
    setLookupList((state) => ({
      ...state,
      departmentList: Data,
    }));
  }, []);
  const fetchCurrencyLookup = useCallback(async () => {
    const p = {
      Module: "AP",
      CurrDate: ToMySqlDate(new Date()),
    };
    const arr = await getLookupCurrency(p);
    setLookupList((state) => ({
      ...state,
      currency: arr,
    }));
  }, [ToMySqlDate]);
  const fetchVendorLookup = useCallback(async () => {
    const { Data } = await getApVendorList();
    setLookupList((state) => ({
      ...state,
      vendor: Data,
    }));
  }, []);
  const fetchPaymentTypeLookup = useCallback(async () => {
    const { Data } = await getApPaymentTypeList();
    setLookupList((state) => ({
      ...state,
      apPaymentType: Data,
    }));
  }, []);
  const fetchUnitLookup = useCallback(async () => {
    const { Data } = await getUnitList();
    setLookupList((state) => ({
      ...state,
      unit: Data,
    }));
  }, []);
  const fetchWorkflowByCode = useCallback(async (wfCode) => {
    const r = await getWorkflowByCode(wfCode);
    if (r?.data?.Active) {
      const enumData = await getEnumApInvoiceStatus();
      setWfEnumStatus(enumData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchWorkflowSteps = useCallback(async (wfCode) => {
    const { data } = await getWorkflowStep(wfCode);
    setWfSteps(data);
  }, []);
  const fetchTaxProfile = useCallback(async () => {
    const { Data } = await getTaxProfile();
    setLookupList((state) => ({
      ...state,
      taxProfileList: Data,
    }));
  }, []);

  useEffect(() => {
    if (authenticated) {
      fetchAccLookup();
      fetchDeptLookup();
      fetchVendorLookup();
      fetchCurrencyLookup();
      fetchPaymentTypeLookup();
      fetchUnitLookup();
      fetchWorkflowByCode("AP_INVOICE");
      fetchWorkflowSteps("AP_INVOICE");
      fetchTaxProfile();
    }
  }, [
    authenticated,
    fetchAccLookup,
    fetchDeptLookup,
    fetchVendorLookup,
    fetchCurrencyLookup,
    fetchPaymentTypeLookup,
    fetchUnitLookup,
    fetchWorkflowByCode,
    fetchWorkflowSteps,
    fetchTaxProfile,
  ]);

  const formFieldsEdit = [
    {
      size: 2,
      field: (
        <TextFieldInForm
          label={translate("ra.field.Seq")}
          name="InvhSeq"
          variant="outlined"
          margin="dense"
          InputProps={{
            readOnly: true,
          }}
          disabled={!addMode}
        />
      ),
    },
    {
      size: 2,
      field: (
        <TextFieldInForm
          label={`*${translate("ra.field.Invoice No.")}`}
          name="InvhInvNo"
          variant="outlined"
          margin="dense"
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
            maxLength: {
              value: 30,
              message: "maximum length is 30",
            },
          }}
          disabled={IsSettled}
        />
      ),
    },
    {
      size: 2,
      field: (
        <MuiAutosuggest
          label={`*${translate("ra.field.Vendor")}`}
          name="VnCode"
          optKey="VnCode"
          optDesc="VnName"
          options={lookupList["vendor"]}
          updateOtherField={[
            { key: "VnName", optKey: "VnName" },
            { key: "InvhCredit", optKey: "VnTerm" },
            { key: "BranchNo", optKey: "BranchNo" },
            { key: "TaxId", optKey: "VnTaxNo" },
          ]}
          updateLookupItem={true}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
          disabled={IsSettled}
        />
      ),
    },
    {
      size: 2,
      name: "BranchNo",
      field: (
        <DescInForm
          style={{ marginTop: 8 }}
          name="BranchNo"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
      style: { display: "none" },
    },
    {
      size: 2,
      name: "TaxId",
      field: (
        <DescInForm
          style={{ marginTop: 8 }}
          name="TaxId"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
      style: { display: "none" },
    },
    {
      size: 2,
      name: "VnName",
      field: (
        <DescInForm
          style={{ marginTop: 8 }}
          name="VnName"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
    },
    {
      size: 2,
      field: (
        <MuiAutosuggest
          label={`*${translate("ra.field.Currency")}`}
          name="CurCode"
          optKey="CurrCode"
          optDesc="CurrRate"
          options={lookupList["currency"]}
          updateOtherField={[{ key: "CurRate", optKey: "CurrRate" }]}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
          disabled={IsSettled}
        />
      ),
    },
    {
      size: 2,
      field: (
        <NumberFormatInForm
          label={`*${translate("ra.field.Rate")}`}
          name="CurRate"
          rule={{
            min: {
              value: 0.000001,
              message: "* Required",
            },
            required: {
              value: true,
              message: "* Required",
            },
          }}
          decimal={SettingSystem.CurrencyRateDecimal}
          // decimalSep={SettingSystem.DecimalSeparator}
          // thousandSep={SettingSystem.ThousandSeparator}
          disabled={IsSettled}
        />
      ),
    },
    {
      size: 2,
      field: (
        <DateInForm
          label={translate("ra.field.Input Date")}
          name="InvhDate"
          minDate={!IsSettled ? new Date(newClosePeriodAp) : undefined}
          minDateMessage={"Date must be more than close period"}
          //for custom advance update field
          useFncUpdate={true}
          fncUpdate={async (value, methods) => {
            const p = {
              Module: "AP",
              CurrDate: ToMySqlDate(value),
            };
            const newCurrList = await getLookupCurrency(p);
            const currentCurCode = methods.watch("CurCode");
            const currentCurRate = methods.watch("CurRate");
            const newCurrRate = newCurrList.find(
              (i) => i.CurrCode === currentCurCode,
            ).CurrRate;
            if (newCurrRate !== ToNumber(currentCurRate)) {
              SnackbarUtils.confirm(
                translate("ra.question.currencyWarning"),
                function () {
                  methods.setValue("CurRate", newCurrRate);
                },
              );
            }
            setLookupList((state) => ({
              ...state,
              currency: newCurrList,
            }));
          }}
          required
          disabled={IsSettled}
        />
      ),
    },
    {
      size: 2,
      field: (
        <DateInForm
          label={translate("ra.field.Invoice Date")}
          name="InvhInvDate"
          minDate={!IsSettled ? new Date(newClosePeriodAp) : undefined}
          minDateMessage={"Date must be more than close period"}
          required
          disabled={IsSettled}
        />
      ),
    },
    {
      size: 2,
      field: (
        <NumberFormatInForm
          label={translate("ra.field.Credit")}
          name="InvhCredit"
          decimal={0}
          rule={{
            maxLength: {
              value: 3,
              message: "maximum length is 3",
            },
          }}
          disabled={IsSettled}
        />
      ),
    },
    {
      size: 2,
      field: (
        <DateInForm
          label={translate("ra.field.Due Date")}
          name="InvhDueDate"
          minDate={!IsSettled ? new Date(newClosePeriodAp) : undefined}
          minDateMessage={"Date must be more than close period"}
          required
          disabled={IsSettled}
        />
      ),
    },
    // {
    //   size: 4,
    //   field: <div></div>,
    //   implementation: "css",
    //   smDown: true,
    //   component: { Hidden },
    // },
    {
      size: 4,
      field: (
        <TextFieldInForm
          label={translate("ra.field.Description")}
          name="InvhDesc"
          variant="outlined"
          margin="dense"
          multiline
          rows={5}
          rule={{
            maxLength: {
              value: 255,
              message: "maximun length is 255",
            },
          }}
        />
      ),
    },
    {
      size: 2,
      field: (
        <TextFieldInForm
          label={translate("ra.field.Tax Inv No.")}
          name="InvhTInvNo"
          variant="outlined"
          margin="dense"
          rule={{
            maxLength: {
              value: 30,
              message: "maximum length is 30",
            },
          }}
        />
      ),
      style: { marginTop: -70 },
    },
    {
      size: 2,
      field: (
        <DateInForm
          label={translate("ra.field.Tax Inv Date")}
          name="InvhTInvDt"
          minDate={!IsSettled ? new Date(newClosePeriodGl) : undefined}
          minDateMessage={"Date must be more than close period"}
          required
        />
      ),
      style: { marginTop: -70 },
    },
    {
      size: 2,
      field: (
        <SelectInForm
          label={translate("ra.field.Tax Status")}
          name="TaxStatus"
          options={InvoiceTaxStatusOptions}
        />
      ),
      style: { marginTop: -70 },
    },
    {
      size: 2,
      field: (
        <SelectInForm
          label={translate("ra.field.Tax Period")}
          name="TaxPeriod"
          options={PeriodList()}
        />
      ),
      style: { marginTop: -70 },
    },
  ];

  const formFieldsDetail = [
    {
      size: 12,
      field: (
        <TextFieldInForm
          label={translate("ra.field.Comment")}
          name="InvdDesc"
          variant="outlined"
          margin="dense"
          multiline
          rows={3}
          rule={{
            maxLength: {
              value: 255,
              message: "maximum length is 255",
            },
          }}
        />
      ),
    },
    {
      size: 4,
      field: (
        <MuiAutosuggest
          label={`*${translate("ra.field.Unit")}`}
          name="UnitCode"
          optKey="UnitCode"
          optDesc="Description"
          options={lookupList["unit"]}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
        />
      ),
    },
    {
      size: 4,
      field: (
        <NumberFormatInForm
          label={`*${translate("ra.field.Qty")}`}
          name="InvdQty"
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
          decimal={SettingSystem.BaseQtyDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
        />
      ),
    },
    {
      size: 4,
      field: (
        <NumberFormatInForm
          label={`*${translate("ra.field.Price/Unit")}`}
          name="InvdPrice"
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
          decimal={SettingSystem.CostPerUnitBaseDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
        />
      ),
    },
    {
      size: 4,
      field: (
        <MuiAutosuggest
          label={`*${translate("ra.field.Dr Dept. Code")}`}
          name="DeptCode"
          optKey="DeptCode"
          optDesc="Description"
          options={lookupList["departmentList"]}
          updateOtherField={[{ key: "DeptDesc", optKey: "Description" }]}
          useFncUpdate={true}
          fncUpdate={(value, methods) => {
            const daccList = value?.DefaultAccount
              ? JSON.parse(value.DefaultAccount)
              : [];
            if (daccList?.length > 0) {
              setLookupList((state) => ({
                ...state,
                accountCodeListDR: daccList,
              }));
              //remove acc if not in defaultaccount
              const drAcc = methods.getValues("InvdBTaxDr");
              if (drAcc !== "" && !daccList.find((i) => i.AccCode === drAcc)) {
                methods.setValue("InvdBTaxDr", "");
                methods.setValue("InvdBTaxDrDesc", "");
              }
            } else {
              setLookupList((state) => ({
                ...state,
                accountCodeListDR: oldAccList,
              }));
            }
          }}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
        />
      ),
    },
    {
      size: 8,
      name: "DeptDesc",
      field: (
        <DescInForm
          name="DeptDesc"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
    },
    {
      size: 4,
      field: (
        <MuiAutosuggest
          label={`*${translate("ra.field.Dr Acc. Code")}`}
          name="InvdBTaxDr"
          optKey="AccCode"
          optDesc={locale === "en-US" ? "Description" : "Description2"}
          options={lookupList["accountCodeListDR"]}
          updateOtherField={[
            {
              key: "InvdBTaxDrDesc",
              optKey: locale === "en-US" ? "Description" : "Description2",
            },
          ]}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
        />
      ),
    },
    {
      size: 4,
      name: "InvdBTaxDrDesc",
      field: (
        <DescInForm
          name="InvdBTaxDrDesc"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
    },
    {
      size: 4,
      name: "NetAmt",
      field: (
        <NumberFormatInForm
          label={translate("ra.field.Amount")}
          name="NetAmt"
          decimal={SettingSystem.CurrencyBaseDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
          readOnly
        />
      ),
    },
    // {
    //   size: 4,
    //   field: <div></div>,
    //   implementation: "css",
    //   smDown: true,
    //   component: { Hidden },
    // },
    {
      size: 4,
      field: (
        <MuiAutosuggest
          label={`*${translate("ra.field.Cr Dept. Code")}`}
          name="InvdBTaxCr1DeptCode"
          optKey="DeptCode"
          optDesc="Description"
          options={lookupList["departmentList"]}
          updateOtherField={[
            { key: "InvdBTaxCr1DeptDesc", optKey: "Description" },
          ]}
          useFncUpdate={true}
          fncUpdate={(value, methods) => {
            const daccList = value?.DefaultAccount
              ? JSON.parse(value.DefaultAccount)
              : [];
            if (daccList?.length > 0) {
              setLookupList((state) => ({
                ...state,
                accountCodeListCR: daccList,
              }));
              //remove acc if not in defaultaccount
              const crAcc = methods.getValues("InvdBTaxCr1");
              if (crAcc !== "" && !daccList.find((i) => i.AccCode === crAcc)) {
                methods.setValue("InvdBTaxCr1", "");
                methods.setValue("InvdBTaxCr1Desc", "");
              }
            } else {
              setLookupList((state) => ({
                ...state,
                accountCodeListCR: oldAccList,
              }));
            }
          }}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
        />
      ),
    },
    {
      size: 8,
      name: "InvdBTaxCr1DeptDesc",
      field: (
        <DescInForm
          name="InvdBTaxCr1DeptDesc"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
    },
    {
      size: 4,
      field: (
        <MuiAutosuggest
          label={`*${translate("ra.field.Cr Acc. Code")}`}
          name="InvdBTaxCr1"
          optKey="AccCode"
          optDesc={locale === "en-US" ? "Description" : "Description2"}
          options={lookupList["accountCodeListCR"]}
          updateOtherField={[
            {
              key: "InvdBTaxCr1Desc",
              optKey: locale === "en-US" ? "Description" : "Description2",
            },
          ]}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
        />
      ),
    },
    {
      size: 4,
      name: "InvdBTaxCr1Desc",
      field: (
        <DescInForm
          name="InvdBTaxCr1Desc"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
    },
    {
      size: 4,
      name: "TotalAmt",
      field: (
        <NumberFormatInForm
          label={translate("ra.field.Total")}
          name="TotalAmt"
          decimal={SettingSystem.CurrencyBaseDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
          readOnly
        />
      ),
    },
  ];

  const formFieldsTax1 = [
    {
      size: 4,
      field: (
        <MuiAutosuggest
          label={`* Tax Profile 1`}
          name="TaxProfileCode1"
          optKey="Code"
          optDesc={"Description"}
          options={lookupList["taxProfileList"]}
          //updateOtherField={[{ key: "InvdTaxR1", optKey: "TaxRate" }]}
          useFncUpdate={true}
          fncUpdate={(value, methods) => {
            if (!value) {
              methods.setValue("InvdTaxT1", "None");
              methods.setValue("InvdTaxR1", 0);
            } else {
              if (value.TaxRate === 0) {
                methods.setValue("InvdTaxT1", "None");
                methods.setValue("InvdTaxR1", 0);
              } else {
                methods.setValue("InvdTaxT1", "Add");
                methods.setValue("InvdTaxR1", value.TaxRate);
              }
            }
          }}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
        />
      ),
    },
    {
      size: 8,
      field: <div></div>,
      implementation: "css",
      smDown: true,
      component: { Hidden },
    },
    {
      size: 4,
      field: (
        <SelectInForm
          label={`${translate("ra.field.Tax Type")}1`}
          name="InvdTaxT1"
          options={VatTypeOptions}
        />
      ),
    },
    {
      size: 4,
      field: (
        <NumberFormatInForm
          label={`${translate("ra.field.Tax Rate")}1`}
          name="InvdTaxR1"
          decimal={SettingSystem.CurrencyBaseDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
          disabled
        />
      ),
      style: { marginTop: 4 },
    },
    {
      size: 4,
      field: (
        <CheckBoxInForm
          label={translate("ra.field.Overwrite")}
          name="Tax1overwrite"
          disabledByTaxType={"InvdTaxT1"}
        />
      ),
    },
    {
      size: 4,
      field: (
        <MuiAutosuggest
          label={`${translate("ra.field.Tax Dr Dept. Code")}1`}
          name="InvdT1DrDeptCode"
          optKey="DeptCode"
          optDesc="Description"
          options={lookupList["departmentList"]}
          updateOtherField={[
            { key: "InvdT1DrDeptDesc", optKey: "Description" },
          ]}
          useFncUpdate={true}
          fncUpdate={(value, methods) => {
            const daccList = value?.DefaultAccount
              ? JSON.parse(value.DefaultAccount)
              : [];
            if (daccList?.length > 0) {
              setLookupList((state) => ({
                ...state,
                accountCodeListTAX: daccList,
              }));
              //remove acc if not in defaultaccount
              const drTax1Acc = methods.getValues("InvdT1Dr");
              //let drTax2Acc = methods.getValues("InvdT2Dr");
              if (
                drTax1Acc !== "" &&
                !daccList.find((i) => i.AccCode === drTax1Acc)
              ) {
                methods.setValue("InvdT1Dr", "");
                methods.setValue("InvdT1DrDesc", "");
              }
              // if (
              // 	drTax2Acc !== "" &&
              // 	!daccList.find((i) => i.AccCode === drTax2Acc)
              // ) {
              // 	methods.setValue("InvdT2Dr", "");
              // 	methods.setValue("InvdT2DrDesc", "");
              // }
            } else {
              setLookupList((state) => ({
                ...state,
                accountCodeListTAX: oldAccList,
              }));
            }
          }}
        />
      ),
    },
    {
      size: 8,
      name: "InvdT1DrDeptDesc",
      field: (
        <DescInForm
          name="InvdT1DrDeptDesc"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
    },
    {
      size: 4,
      field: (
        <MuiAutosuggest
          label={`${translate("ra.field.Tax Dr Acc. Code")}1`}
          name="InvdT1Dr"
          optKey="AccCode"
          optDesc={locale === "en-US" ? "Description" : "Description2"}
          options={lookupList["accountCodeListTAX"]}
          updateOtherField={[
            {
              key: "InvdT1DrDesc",
              optKey: locale === "en-US" ? "Description" : "Description2",
            },
          ]}
        />
      ),
    },
    {
      size: 4,
      name: "InvdT1DrDesc",
      field: (
        <DescInForm
          name="InvdT1DrDesc"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
    },
    {
      size: 4,
      field: (
        <NumberFormatInForm
          label={translate("ra.field.Tax 1")}
          name="InvdTaxC1"
          decimal={SettingSystem.CurrencyBaseDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
        />
      ),
    },
  ];

  const formFieldsTax2 = [
    {
      size: 4,
      field: (
        <MuiAutosuggest
          label={`Tax Profile 2`}
          name="TaxProfileCode2"
          optKey="Code"
          optDesc={"Description"}
          options={lookupList["taxProfileList"]}
          //updateOtherField={[{ key: "InvdTaxR1", optKey: "TaxRate" }]}
          useFncUpdate={true}
          fncUpdate={(value, methods) => {
            if (!value) {
              methods.setValue("InvdTaxT2", "None");
              methods.setValue("InvdTaxR2", 0);
            } else {
              if (value.TaxRate === 0) {
                methods.setValue("InvdTaxT2", "None");
                methods.setValue("InvdTaxR2", 0);
              } else {
                methods.setValue("InvdTaxT2", "Add");
                methods.setValue("InvdTaxR2", value.TaxRate);
              }
            }
          }}
        />
      ),
    },
    {
      size: 8,
      field: <div></div>,
      implementation: "css",
      smDown: true,
      component: { Hidden },
    },
    {
      size: 4,
      field: (
        <SelectInForm
          label={`${translate("ra.field.Tax Type")}2`}
          name="InvdTaxT2"
          options={VatTypeOptions}
        />
      ),
    },
    {
      size: 4,
      field: (
        <NumberFormatInForm
          label={`${translate("ra.field.Tax Rate")}2`}
          name="InvdTaxR2"
          decimal={SettingSystem.CurrencyBaseDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
          disabled
        />
      ),
    },
    {
      size: 4,
      field: (
        <CheckBoxInForm
          label={translate("ra.field.Overwrite")}
          name="Tax2overwrite"
        />
      ),
    },
    {
      size: 4,
      field: (
        <MuiAutosuggest
          label={`${translate("ra.field.Tax Dr Dept. Code")}2`}
          name="InvdT2DrDeptCode"
          optKey="DeptCode"
          optDesc="Description"
          options={lookupList["departmentList"]}
          updateOtherField={[
            { key: "InvdT2DrDeptDesc", optKey: "Description" },
          ]}
          useFncUpdate={true}
          fncUpdate={(value, methods) => {
            const daccList = value?.DefaultAccount
              ? JSON.parse(value.DefaultAccount)
              : [];
            if (daccList?.length > 0) {
              setLookupList((state) => ({
                ...state,
                accountCodeListTAX2: daccList,
              }));
              //remove acc if not in defaultaccount
              const drTax2Acc = methods.getValues("InvdT2Dr");
              if (
                drTax2Acc !== "" &&
                !daccList.find((i) => i.AccCode === drTax2Acc)
              ) {
                methods.setValue("InvdT2Dr", "");
                methods.setValue("InvdT2DrDesc", "");
              }
            } else {
              setLookupList((state) => ({
                ...state,
                accountCodeListTAX2: oldAccList,
              }));
            }
          }}
        />
      ),
    },
    {
      size: 8,
      name: "InvdT2DrDeptDesc",
      field: (
        <DescInForm
          name="InvdT2DrDeptDesc"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
    },
    {
      size: 4,
      field: (
        <MuiAutosuggest
          label={`${translate("ra.field.Tax Dr Acc. Code")}2`}
          name="InvdT2Dr"
          optKey="AccCode"
          optDesc={locale === "en-US" ? "Description" : "Description2"}
          options={lookupList["accountCodeListTAX2"]}
          updateOtherField={[
            {
              key: "InvdT2DrDesc",
              optKey: locale === "en-US" ? "Description" : "Description2",
            },
          ]}
        />
      ),
    },
    {
      size: 4,
      name: "InvdT2DrDesc",
      field: (
        <DescInForm
          name="InvdT2DrDesc"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
    },
    {
      size: 4,
      field: (
        <NumberFormatInForm
          label={translate("ra.field.Tax 2")}
          name="InvdTaxC2"
          decimal={SettingSystem.CurrencyBaseDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
        />
      ),
    },
  ];

  if (addMode) {
    return (
      <Create
        {...props}
        formFields={formFieldsEdit}
        formFieldsDetail={formFieldsDetail}
        formFieldsTax1={formFieldsTax1}
        formFieldsTax2={formFieldsTax2}
        useStyles={useStyles}
      />
    );
  } else {
    return (
      <Edit
        {...props}
        copyMode={copyMode}
        isSettled={IsSettled}
        formFields={formFieldsEdit}
        formFieldsDetail={formFieldsDetail}
        formFieldsTax1={formFieldsTax1}
        formFieldsTax2={formFieldsTax2}
        wfEnumStatus={wfEnumStatus}
        wfSteps={wfSteps}
        useStyles={useStyles}
      />
    );
  }
};

const ViewMode = (props) => {
  const [wfActive, setWfActive] = useState(false);
  const [wfSteps, setWfSteps] = useState();
  const [wfEnumStatus, setWfEnumStatus] = useState();
  const [hideMailBtn, setHideMailBtn] = useState(false);
  const fetchMail = useCallback(async (pCode) => {
    const r = await getMailProfile(pCode);
    if (r?.Active) {
      setHideMailBtn(false);
    } else {
      setHideMailBtn(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchWorkflowByCode = useCallback(async (wfCode) => {
    const r = await getWorkflowByCode(wfCode);
    if (r?.data?.Active) {
      setWfActive(true);
      const enumData = await getEnumApInvoiceStatus();
      setWfEnumStatus(enumData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchWorkflowSteps = useCallback(async (wfCode) => {
    const { data } = await getWorkflowStep(wfCode);
    setWfSteps(data);
  }, []);

  useEffect(() => {
    fetchMail("AP_Invoice");
    fetchWorkflowByCode("AP_INVOICE");
    fetchWorkflowSteps("AP_INVOICE");
  }, [fetchMail, fetchWorkflowByCode, fetchWorkflowSteps]);

  return (
    <Show
      {...props}
      useStyles={useStyles}
      hideMailBtn={hideMailBtn}
      wfActive={wfActive}
      wfEnumStatus={wfEnumStatus}
      wfSteps={wfSteps}
    />
  );
};

export default {
  list: List,
  show: ViewMode,
  edit: SwitchActionMode,
  create: SwitchActionMode,
};
